<template>
  <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Add Vehicle Staff Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehicleStaff' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
      <v-row>
        <v-col cols="12" lg="4" sm="6" >
        <span class="body-2 font-weight-medium"> Academic Year</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required v-model="academicYearID" key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="academicYears" item-text="academicYear" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Select Franchisee</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="franchiseeID" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="franchiseeArr" item-text="companyName" item-value="id">
        </v-autocomplete>
      </v-col>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Name <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="name" required class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
     <v-row>
        <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Mobile Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="mobileNumber" required class="my-0 py-1"  maxlength="10"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          type="number"
          counter="10">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Email <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="email" required class="my-0 py-1" type="email">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Unique Identification Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="uniqueIdentificationNumber" required class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
         <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> License Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="licenseNumber" required class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium"> License Expiry Date <span class="error--text ml-1">*</span></label>
              <custom-date-picker v-model="licenseExpiryDate" />
            </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Roles</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="rolesdata" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="rolesArray" item-text="role" item-value="id">
        </v-autocomplete>
      </v-col>
    </v-row>
</v-col>
</v-row>
  <div class="columns form-row">
    <v-col cols="12" md="4">
                <label class="font-weight-medium body-2">
                  Password
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field
                  class="my-0 py-1"
                  placeholder="*******"
                  autocomplete="new-password"
                  type="password"
                  v-model="password"
                  maxlength="20"
                  password-reveal
                ></v-text-field>
              </v-col>
             <v-col cols="12" md="6" lg="4">
              <label class="body-2 font-weight-medium">Select Photo<span class="has-text-danger">*</span></label>
              <v-file-input :messages="['(Only .jpg, .jpeg , .png format is allowed)']" :required="isDocRequired" class="my-0 py-1"
              v-model="dropFile" accept="image/*" @input="onFilechange()" show-size placeholder="Click to Upload"></v-file-input>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <label class="body-2 font-weight-medium">Select licence<span class="has-text-danger">*</span></label>
              <v-file-input :messages="['(Only .jpg, .jpeg , .png format is allowed)']" :required="isDocRequired" class="my-0 py-1"
              v-model="licence" accept="image/*" @input="onFilechange()" show-size placeholder="Click to Upload"></v-file-input>
            </v-col>
          </div>
          <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;">Create</button>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'
import _ from 'lodash'
export default {
  name: 'addVehicleStaff',
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      licence: [],
      franchiseeID: '',
      rolesdata: '',
      name: '',
      mobileNumber: '',
      email: '',
      uniqueIdentificationNumber: '',
      licenseNumber: '',
      password: '',
      licenseExpiryDate: '',
      roles: [],
      role: [],
      franchiseeArr: [],
      academicYearID: '',
      isRequired: false,
      selectedFranchisee: [],
      academicYears: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      rolesArray: [],
      isDocRequired: true,
      Positions: [
        { id: 1, name: 'Driver', value: 'Driver' },
        { id: 2, name: 'Cleaner', value: 'Cleaner' }
      ],
      allowedFiles: [
        'png', 'jpg', 'jpeg']
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
    await this.getRoleList()
  },
  methods: {
    getRoleList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/roles`)
        this.rolesArray = data

        this.isLoading = false
        this.rolesArray = _.filter(
          this.rolesArray, function (o) {
            return o.role === 'Driver' || o.role === 'Cleaner'
          }
        )
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching role', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
      this.licence.splice(i, 1)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        let sendRole = this.rolesdata
        let Roledata = _.filter(
          this.rolesArray, function (o) {
            return o.id === sendRole
          }
        )
        this.role = Roledata[0].id
        this.roles = Roledata[0].role
        this.loadingComponent = this.$buefy.loading.open()
        if (this.licenseExpiryDate === '') {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter License Expiry Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let formData = new FormData()
        formData.append('franchiseeID', this.franchiseeID)
        formData.append('academicYearID', this.academicYearID)
        formData.append('firstName', this.name)
        formData.append('mobile', this.mobileNumber)
        formData.append('email', this.email)
        formData.append('uniqueIdentificationNumber', this.uniqueIdentificationNumber)
        formData.append('licenseNumber', this.licenseNumber)
        formData.append('licenseExpiryDate', this.licenseExpiryDate)
        formData.append('password', this.password)
        formData.append('roleId', this.role)
        formData.append('roles', this.roles)
        formData.append('vehicleStaffPhoto', this.dropFile)
        formData.append('vehicleStaffLicenseAttachements', this.licence)
        for (var pair of formData.entries()) {
          console.log(pair)
        }
        this.hasClicked = true

        await http.post(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleStaff' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onFilechange () {
      let r = this.dropFile.type !== 'image/jpeg' && this.dropFile.type !== 'image/jpg' && this.dropFile.type !== 'image/png'
      let t = this.licence.type !== 'image/jpeg' && this.licence.type !== 'image/jpg' && this.licence.type !== 'image/png'
      if (r === true) {
        this.dropFile.pop()
        return this.$dialog.error({
          text: 'please select jpeg , jpg , png format only',
          title: 'Error'
        })
      }
      if (t === true) {
        this.licence.pop()
        return this.$dialog.error({
          text: 'please select jpeg , jpg , png format only',
          title: 'Error'
        })
      }
    }
  }
}
</script>
